"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.legacyConstructEIP712Tx = void 0;
const eip712_1 = require("../constant/eip712");
const ethermint_1 = require("../util/ethermint");
const codec_1 = require("../codec");
const AminoTypesMap_1 = __importDefault(require("../provider/amino/AminoTypesMap"));
const lodash_1 = require("lodash");
function getTypes(msgTypeUrl, aminoMsgValue) {
    return Object.assign(Object.assign({}, eip712_1.LEGACY_DEFAULT_EIP712_TYPES), getMsgValueType(msgTypeUrl, aminoMsgValue, "MsgValue"));
}
function getMsgValueType(msgTypeUrl, msgValue, msgTypeName, objectName, nestedType = false, msgTypeDefinitions = {}) {
    const packageName = msgTypeUrl.split(".").slice(0, -1).join(".");
    const msgFieldType = msgTypeUrl.split(".").pop();
    const typeName = getTypeName(msgTypeName, objectName, nestedType, false);
    const fieldsDefinition = codec_1.EIP712Types[packageName][msgFieldType];
    if (isNonZeroField(msgValue)) {
        if (!msgTypeDefinitions[typeName]) {
            msgTypeDefinitions[typeName] = [];
        }
        fieldsDefinition.forEach(({ packageName, name, type }) => {
            let fieldValue;
            if (Array.isArray(msgValue)) {
                //Assumption: Take first value in array to determine which fields are populated
                fieldValue = msgValue.length > 0 ? msgValue[0][name] : [];
            }
            else {
                fieldValue = msgValue[name];
            }
            if (isNonZeroField(fieldValue)) {
                //For nested structs
                if (packageName) {
                    const isArray = type.includes('[]') ? true : false;
                    const objectName = typeName === 'MsgValue' ? 'MsgValue' : typeName.split('Type')[1];
                    const nestedType = getTypeName(name, objectName, true, isArray);
                    msgTypeDefinitions[typeName] = [...msgTypeDefinitions[typeName], { name, type: nestedType }];
                    //Special logic if nested struct is google protobuf's Any type
                    if (isGoogleProtobufAnyPackage(packageName, type)) {
                        const nestedAnyTypeName = isArray ? nestedType.split('[]')[0] : nestedType;
                        const nestedAnyValueType = `${nestedAnyTypeName}Value`;
                        msgTypeDefinitions[nestedAnyTypeName] = [{ name: "type", type: "string" }, { name: "value", type: nestedAnyValueType }];
                        const anyObjectTypeNameSplit = nestedAnyTypeName.split('Type')[1];
                        const messageTypeUrl = AminoTypesMap_1.default.fromAmino(fieldValue).typeUrl;
                        getMsgValueType(messageTypeUrl, fieldValue.value, "value", anyObjectTypeNameSplit, true, msgTypeDefinitions);
                    }
                    else {
                        const typeStructName = type.includes('[]') ? type.split('[]')[0] : type;
                        const messageTypeUrl = `${packageName}.${typeStructName}`;
                        getMsgValueType(messageTypeUrl, fieldValue, name, objectName, true, msgTypeDefinitions);
                    }
                }
                else {
                    msgTypeDefinitions[typeName] = [...msgTypeDefinitions[typeName], { name, type }];
                }
            }
        });
    }
    return msgTypeDefinitions;
}
function getTypeName(name, objectName, nestedType = false, isArray = false) {
    if (nestedType) {
        return `Type${objectName === 'MsgValue' ? '' : objectName}${name.split('_').map(subName => (0, lodash_1.capitalize)(subName)).join('')}${isArray ? '[]' : ''}`;
    }
    return name;
}
function isGoogleProtobufAnyPackage(packageName, type) {
    return packageName === '/google.protobuf' && type == 'Any';
}
function isNonZeroField(fieldValue) {
    // zero fields are considered falsey
    if (fieldValue == "0") {
        return false;
    }
    // empty arrays are considered truthy
    if (Array.isArray(fieldValue)) {
        return fieldValue.length !== 0;
    }
    // empty objects are considered truthy
    if (fieldValue && typeof fieldValue === 'object' && Object.keys(fieldValue).length === 0) {
        return false;
    }
    return fieldValue;
}
function legacyConstructEIP712Tx(doc) {
    // Legacy EIP-712 can only accept batch msgs of the same type
    const msg = doc.msgs[0];
    const eip712Tx = {
        types: getTypes(AminoTypesMap_1.default.fromAmino(msg).typeUrl, msg.value),
        primaryType: "Tx",
        domain: Object.assign(Object.assign({}, eip712_1.DEFAULT_CARBON_DOMAIN_FIELDS), { chainId: (0, ethermint_1.parseChainId)(doc.chain_id) }),
        message: doc,
    };
    return eip712Tx;
}
exports.legacyConstructEIP712Tx = legacyConstructEIP712Tx;
